/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Filter cases by severity
 * @export
 */
export const ControlSeverity7 = {
    Informational: 'INFORMATIONAL',
    Low: 'LOW',
    Medium: 'MEDIUM',
    High: 'HIGH',
    Critical: 'CRITICAL'
} as const;
export type ControlSeverity7 = typeof ControlSeverity7[keyof typeof ControlSeverity7];


export function ControlSeverity7FromJSON(json: any): ControlSeverity7 {
    return ControlSeverity7FromJSONTyped(json, false);
}

export function ControlSeverity7FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSeverity7 {
    return json as ControlSeverity7;
}

export function ControlSeverity7ToJSON(value?: ControlSeverity7 | null): any {
    return value as any;
}

